/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { InstructionGenerationOutputDto } from './InstructionGenerationOutputDto';
import {
    InstructionGenerationOutputDtoFromJSON,
    InstructionGenerationOutputDtoFromJSONTyped,
    InstructionGenerationOutputDtoToJSON,
    InstructionGenerationOutputDtoToJSONTyped,
} from './InstructionGenerationOutputDto';

/**
 * 
 * @export
 * @interface InstructionListResponseDto
 */
export interface InstructionListResponseDto {
    /**
     * List of instructions
     * @type {Array<InstructionGenerationOutputDto>}
     * @memberof InstructionListResponseDto
     */
    instructions?: Array<InstructionGenerationOutputDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof InstructionListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the InstructionListResponseDto interface.
 */
export function instanceOfInstructionListResponseDto(value: object): value is InstructionListResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function InstructionListResponseDtoFromJSON(json: any): InstructionListResponseDto {
    return InstructionListResponseDtoFromJSONTyped(json, false);
}

export function InstructionListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'instructions': json['instructions'] == null ? undefined : ((json['instructions'] as Array<any>).map(InstructionGenerationOutputDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function InstructionListResponseDtoToJSON(json: any): InstructionListResponseDto {
    return InstructionListResponseDtoToJSONTyped(json, false);
}

export function InstructionListResponseDtoToJSONTyped(value?: InstructionListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instructions': value['instructions'] == null ? undefined : ((value['instructions'] as Array<any>).map(InstructionGenerationOutputDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

